import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";


const InputContainer = styled.div`
  position: relative;
  padding: .4rem .6rem;
`;

const SubmitButton = styled.button`
  font-size: 1rem;
  padding: 0.54rem 1.5rem;
  border-radius: 3px;
  cursor: pointer;
  color: ${props => props.theme.textColor || "white"};
  background-color: ${props => props.theme.backColor || "hsl(217, 40%, 35%)"};
  border: 1px solid ${props => props.theme.backColor || "hsl(217, 40%, 35%)"};

  &:disabled {
    background-color: #ccc;
    border-color: #f9f9f9;
    color: #333;

  }
`;
const InputElement = styled.input`
  margin: 1.2rem auto 0 auto;
  padding: 0.5rem;
  border-radius: 2px;
  resize: horizontal;
  color: ${props => props.theme.textColor || "#333"};
  background-color: ${props => props.theme.backColor || "white"};
  border: 1px solid ${props => props.theme.borderColor || "#ccc"};
  width: ${props => props.theme.width || "60%"};
  
  &:placeholder-shown + label {
    opacity: 0;
    transform: translateY(1rem);
    font-size: 80%;
  }
`;
const TextAreaElement = styled.textarea`
  margin: 0.8rem auto;
  padding: 0.5rem;
  resize: vertical;
  border-radius: 2px;
  font-family: inherit;
  color: ${props => props.theme.textColor || "#333"};
  background-color: ${props => props.theme.backColor || "white"};
  border: 1px solid ${props => props.theme.borderColor || "#ccc"};
  width: ${props => props.theme.width || "80%"};
`;
const LabelElement = styled.label`
  opacity: 1;
  position: absolute;
  top: 0;
  transform: translateY(0);
  transition: all 0.2s ease-out;
  left: 10px;
  display: block;
  font-weight: 500;
  color: ${props => props.theme.labelColor || "hsl(217, 39%, 40%)"};
`;

function Input(props) {
  return (
    <InputContainer>
      <InputElement 
        type={props.type} 
        name={props.name} 
        ref={props.ref} 
        value={props.value}
        onChange={props.handleInputChange}
        placeholder={props.placeholder}
        required={props.required}
      />
      <LabelElement htmlFor={props.name}>
        {props.label}
      </LabelElement>
    </InputContainer>
  )
}
Input.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  ref: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  theme: PropTypes.array.isRequired,
}
Input.defaultProps = {
  onChange: () => {}
}
function TextArea(props) {
  return (
    <InputContainer>
      <TextAreaElement
        name={props.name}
        value={props.value}
        rows={props.rows}
        onChange={props.handleInputChange}
        placeholder={props.placeholder}
      />
    </InputContainer>
  )
}
TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  row: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  theme: PropTypes.array.isRequired,
}
TextArea.defaultProps = {
  onChange: () => {}
}
function FormButton(props) {
  return (
    <InputContainer>
      <SubmitButton type={props.type} disabled={props.disabled}>
        {props.value}
      </SubmitButton>
    </InputContainer>
  )
}

FormButton.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  theme: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
}
export { Input, TextArea, FormButton }



// WEBPACK FOOTER //
// ./src/Components/FormElements/index.js